import React, { useEffect } from 'react';

const DataRetention = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <section className="section aboutPage pt-5 pb-5">
            <div className="container">
                <h1 className="hd mb-4">Data Retention Policy</h1>
                <div className="content">
                    <p>The intent of this Policy is to outline the data retention practices of Paymond Services Private Limited.</p>

                    <h3>Data Retention Schedule</h3>
                    <ul>
                        <li><strong>Customer Data:</strong> 1 Month after the last transaction.</li>
                        <li><strong>Employee Records:</strong> 1 Year after employment termination.</li>
                        <li><strong>Audit Logs:</strong> 1 Month.</li>
                    </ul>

                    <p>This Data Retention Policy sets out the obligations of <strong>Paymond Services Private Limited</strong> and its subsidiaries and affiliates (hereinafter collectively referred to as “Paymond Services Private Limited”, “We”, “Us” or “Our”) regarding retention of personal data collected, held, and processed by Paymond Services Private Limited.</p>

                    <p>The retention of information collected through our website <strong>https://Paymond.in</strong> (the “Site”) and our mobile application the name of Payekin in UK and US and Paymond Services Private Limited in India (the “Application”), collectively “Services” shall be governed by this Policy and is therefore incorporated into our Terms of Use.</p>

                    <p>This Policy is intended to safeguard user records collected and retained by Paymond Services Private Limited. This policy details out what is expected of Paymond Services Private Limited employees and other stakeholders involved in the retention of data and its protection.</p>

                    <p>Personal data shall be kept in a form which permits the identification of users for no longer than is necessary for the reasons why the personal data is processed. In certain cases, personal data may be stored for longer periods where that data is to be processed for archiving purposes that are in the public interest, for scientific or historical research, or for statistical purposes, subject to the implementation of the appropriate technical and organisational measures required to protect that data.</p>

                    <h3>Some Key Terms</h3>
                    <ul>
                        <li><strong>“User(s)”</strong> means our user(s) who use our Services.</li>
                        <li><strong>“User Content”</strong> means all electronic data, text, messages or other materials submitted to the Service(s) by You.</li>
                        <li><strong>“Service Data”</strong> means all electronic data, text, messages or other materials, including personal data of Users.</li>
                        <li><strong>“Personal Data”</strong> means data relating to a living individual who is or can be identified.</li>
                        <li><strong>“Applicable Data Protection Law”</strong> means the General Data Protection Law, Data Protection Act and Personal Data Protection Bill.</li>
                    </ul>

                    <h3>Aims and Objectives</h3>
                    <p>It is necessary to retain and process certain information to enable our business to operate. We may store your data in the following places:</p>
                    <ul>
                        <li>Our own servers</li>
                        <li>Google cloud computing servers</li>
                        <li>Employee-owned devices (BYOD)</li>
                        <li>Desktops</li>
                        <li>Potential backup storages</li>
                    </ul>

                    <h3>Storage and Transfer of Data</h3>
                    <p>Your Personal Data and files are stored on Paymond Services Private Limited servers and the servers of companies we hire to provide services to us i.e. Google Cloud Platform. We have servers located in India; however, your personal information may be transferred across national borders.</p>

                    <h3>Security of Information</h3>
                    <p>Sensitive and private data exchange between our server and our Google cloud platforms happens over an SSL secured communication channel and is encrypted and protected. While we provide administrative, technical, and physical security controls to protect your personal information, no security controls are 100% effective.</p>

                    <h3>Roles and Responsibilities</h3>
                    <p>The grievance officer <strong>Mr. Deepak Singh Mehra</strong> shall be responsible for overseeing the implementation of this Policy and for monitoring compliance. Upon the expiry of the data retention periods, personal data shall be deleted, destroyed, or otherwise disposed of unless as required by the law.</p>

                    <h3>Contact Us</h3>
                    <p>If you have any questions about this Data Retention Policy, please contact us at: <strong>paymondtechnologies@gmail.com</strong></p>
                </div>
            </div>
        </section>
    );
};

export default DataRetention;
